<template lang="pug">
  base-content(ref="main" title="お客様情報変更申請書<span class=\"nopdf\">の作成</span>", :subtitle="subtitle", :type="titleType")
    form(@submit.prevent="submit", data-testid="form-app")
      app-message(v-if="appErrorMessage" type="danger") {{appErrorMessage}}
      app-message(v-if="appInfoMessage" type="info") {{appInfoMessage}}

      button-bar(@downloadDataFile="downloadDataFile" @importData="importData")

      section.section

        form-header(v-if="nextTicker", v-model="postData.application", :showFields="showHeaderFields", :requiredFields="requiredHeaderFields")

        h3.title.required ライセンス証書番号

        section.section
          b-field(
            :message="getInputMessage('application.license_no')",
            :type="getInputType('application.license_no')"
          )
            b-input(
              v-if="isEdit",
              v-model="postData.application.license_no",
              name="application.license_no",
              :required="true",
              :maxlength="maxlen_app.license_no",
              v-validate="",
              data-vv-as="ライセンス証書番号",
              :placeholder="lang_field.licenseNoExample"
              data-testid="application.license_no",
            )
            p(v-else) {{postData.application.license_no}}

          app-message.nopdf(type='info')
            notice-license-number

        h3.title#change_target エンドユーザー様情報

        app-message.nopdf(type="warning")
          li チェックを付けた項目が変更されます。
        p.help.is-danger(v-if="getInputMessage('change_target')") {{getInputMessage('change_target')}}
        p.help.is-danger(v-if="!postData.change_target.length") 変更したい項目を一つ以上選択してください。

        form-user(
          v-if="nextTicker",
          v-model="postData.application",
          prefix="end_",
          :showCheckBox="true",
          :checkedFields="postData.change_target",
          @checked="postData.change_target = $event"
        )

        template(v-if="isPartnerApp()")
          h3.title エンドユーザー様へ販売されるパートナー様情報

          app-message.nopdf(type="warning")
            li チェックを付けた項目が変更されます。
          p.help.is-danger(v-if="getInputMessage('change_target')") {{getInputMessage('change_target')}}
          p.help.is-danger(v-if="!postData.change_target.length") 変更したい項目を一つ以上選択してください。

          form-user(
            v-if="nextTicker",
            v-model="postData.application",
            prefix="partner_",
            :showCheckBox="true",
            :checkedFields="postData.change_target",
            @checked="postData.change_target = $event"
          )

      button-bar(@downloadDataFile="downloadDataFile" @importData="importData")

</template>

<script>
import BaseContent from '@/components/BaseContent'
import ButtonBar from '@/components/apps/com/ButtonBar'
import FormUser from '@/components/apps/com/FormUser'
import FormHeader from '@/components/apps/com/FormHeader'
import NoticeLicenseNumber from '@/components/apps/com/NoticeLicenseNumber'
import AppMessage from '@/components/AppMessage'
import MixinApplication from '@/mixins/application'
import MixinHandleErrors from '@/mixins/handleErrors'
import { Applications as maxlen_app, AppCustomers as maxlen_cst } from '@/config/maxlengths'
import { fields as lang_field } from '@/lang/ja_JP'
import Util from '@/utils/util'

export default {
  name: 'ChangeCustomerInfo',
  mixins: [ MixinApplication, MixinHandleErrors ],
  components: {BaseContent, ButtonBar, FormHeader, FormUser, NoticeLicenseNumber, AppMessage},
  data () {
    return {
      maxlen_app,
      maxlen_cst,
      lang_field,
      Util,

      showHeaderFields: [],
      requiredHeaderFields: [],

      postData: {
        application: {
          order_no: '',
          estimate_no: '',
          license_no: ''
        },
        change_target: []
      },

      /**
       * 選択肢の定義
       * options[ここはフィールド名]
       */
      options: {
        change_target: [
          {value: 'end_org_name'},
          {value: 'end_org_kana'},
          {value: 'end_representative_name'},
          {value: 'end_representative_kana'},
          {value: 'end_dept_name'},
          {value: 'end_chrg_name'},
          {value: 'end_chrg_kana'},
          {value: 'end_tel'},
          {value: 'end_fax'},
          {value: 'end_zipcode'},
          {value: 'end_address'},
          {value: 'end_email'}
        ]
      },

      // PDF作成処理失敗によるエラーメッセージ
      appErrorMessage: '',
      appInfoMessage: ''
    }
  },
  methods: {
    app_getSubmitData () {
      // 共通処理
      let submitData = this.getSubmitData()

      // 個別処理
      submitData.change_target = submitData.change_target.join(',')

      return submitData
    },
    app_validationCheck () {
      if (!this.postData.change_target.length) {
        // エラー位置までスクロールする
        Util.scrollToEl(document.getElementById('change_target'))
        return false
      }
      return true
    },
    app_setImportData (importData) {
      // 共通処理
      this.setImportData(importData, this.postData)

      // 個別処理
      // change_target
      if ('change_target' in importData) {
        // カンマ区切り文字列を配列に変換
        if (typeof importData.change_target === 'string' && importData.change_target.length) {
          this.postData.change_target = importData.change_target.split(',')
        }
        // 配列以外のものがインポートされていた場合、空配列で上書きする
        if (!Array.isArray(this.postData.change_target)) {
          this.postData.change_target = []
        }
      }
    }
  },
  created () {
    this.mode = 'edit'
    this.postData.application = Object.assign(this.postData.application, this.postData__application)
    this.postData.application.app_code = 'cst'

    // AppHeaderの部分を調整
    this.showHeaderFields = ['order_date', 'notes']
    this.requiredHeaderFields = ['order_date']
    delete this.postData.application.order_no
    delete this.postData.application.estimate_no

    if (this.isPartnerApp()) {
      // パートナー用の定義を追加する
      this.options['change_target'] = this.options['change_target'].concat([
        {value: 'partner_org_name'},
        {value: 'partner_org_kana'},
        {value: 'partner_representative_name'},
        {value: 'partner_representative_kana'},
        {value: 'partner_dept_name'},
        {value: 'partner_chrg_name'},
        {value: 'partner_chrg_kana'},
        {value: 'partner_tel'},
        {value: 'partner_fax'},
        {value: 'partner_zipcode'},
        {value: 'partner_address'},
        {value: 'partner_email'}
      ])
    }

    // 初期選択肢をセットする（optionsに定義されているものすべて選択）
    for (let i in this.options.change_target) {
      this.postData.change_target.push(this.options.change_target[i].value)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/apps/ChangeCustomerInfo.vue